require('./modules/client-detect');
require('./modules/namespace');
require('./modules/swiper');

require('./modules/burger-menu');
require('./modules/conf');
require('./modules/detail');
require('./modules/homepage');
require('./modules/lazy-images');
require('./modules/main');
require('./modules/my-swiper');
require('./modules/tab-switch');
require('./modules/top-bar');
require('./modules/utils');
